<template>
    <modal name="vip-buy" @before-open="beforeOpen" @before-close="beforeClose"
        :classes="['v--modal', 'error-modal', 'vip-modal', hasBugs && 'has-bugs']" :width="730" :height="'auto'"
        :adaptive="true">
        <div class="modal-title">
            {{ $t("vipbuy.buyVip") }}
        </div>
        <div class="modal-close" @click="close"></div>
        <div v-if="!initIsEmpty('init') && init.costs" class="modal-body">
            <div class="modal-subtitle">
                {{ $t("vipbuy.selectNumberVip") }}
            </div>

            <ul class="vip-buy-list">
                <li v-for="vip in vipPackages" @click="currentPackage = vip.id" :key="vip.id" class="vip-buy-item"
                    :class="{ 'vip-buy-selected': currentPackage == vip.id }">
                    <span class="vip-buy-text">
                        {{ vip.days }}
                        {{ declineNouns(vip.days, [
                            $t("vipbuy.day"),
                            $t("vipbuy.days"),
                            $t("vipbuy.daysS")
                        ]) }}
                    </span>
                    <br />
                    <span class="vip-buy-price">{{ vip.price }}</span>
                </li>
            </ul>

            <div class="modal-buy-summary">
                <div class="modal-buy-total">
                    {{ vipPackages[currentPackage].days }}
                    {{
                        declineNouns(vipPackages[currentPackage].days, [
                            $t("vipbuy.day"),
                            $t("vipbuy.days"),
                            $t("vipbuy.daysS")
                        ])
                    }}
                    {{ $t("vipbuy.vipZa") }}
                    <span class="vip-buy-price-mobile">
                        {{ vipPackages[currentPackage].price }}
                        {{
                            declineNouns(vipPackages[currentPackage].price, [
                                $t("photoDetails.zarik"),
                                $t("photoDetails.zarika"),
                                $t("photoDetails.zarikov")
                            ])
                        }}
                    </span>
                </div>
                <div v-if="parseFloat(user.balance) <
                        parseFloat(vipPackages[currentPackage].price)
                        " class="modal-buy-balance">
                    <span class="text-warning">{{ $t("vipbuy.insufficientFunds") }}</span>
                    <span @click="$modal.show('balance-in')" class="link-underlined">{{ $t("roulette.refill") }}</span>
                </div>
            </div>

            <div class="buttons-row">
                <button @click="close" type="button" class="button-secondary">
                    {{ $t("stories.cancel") }}
                </button>
                <button @click="confirm" v-if="!loader" class="button">
                    {{ $t("stories.continue") }}
                </button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
            <div v-if="user.vip && vipRemain" class="modal-subtitle">
                {{ $t("vipbuy.yourVIPExpiring") }}
                <span v-if="vipRemain > 0">
                    {{ $t("vipbuy.through") }} {{ vipRemain }}
                    {{ declineNouns(vipRemain, [
                        $t("vipbuy.day"),
                        $t("vipbuy.days"),
                        $t("vipbuy.daysS")
                    ]) }}
                </span>
                <span v-else>{{ $t("vipbuy.today") }}</span>
            </div>
            <div v-else class="modal-subtitle">{{ $t("vipbuy.yourVIPActivated") }}</div>
            <ul class="modal-list">
                <li class="modal-list-item">
                    {{ $t("vipbuy.findOutPage") }}
                </li>
                <li class="modal-list-item">
                    {{ $t("vipbuy.blockUnwantedUsers") }}
                </li>
                <li class="modal-list-item">{{ $t("vipbuy.receiveDiscountsPurchases") }}</li>
                <li class="modal-list-item">{{ $t("vipbuy.writeToUser") }}</li>
                <li class="modal-list-item">{{ $t("vipbuy.specialPrivacySettings") }}</li>
            </ul>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { formatDateTime } from "@/mixins/formatDateTime";
import { checkScroll } from "@/mixins/checkScroll";

export default {
    name: "VipBuy",
    props: {
        i18n: Object,
    },
    mixins: [declineNouns, formatDateTime, checkScroll],
    data() {
        return {
            hasBugs: false,
            loader: false,
            currentPackage: 0,
        };
    },
    computed: {
        ...mapGetters({
            user: "user/fetchUser",
            profile: "profile/get",
            profileErrors: "profile/errors",
            init: "init/fetchInit",
            initIsEmpty: "init/isEmpty",
        }),
        vipRemain() {
            let period = this.user.vip_end * 1000 - +new Date();
            return Math.ceil(period / (1000 * 3600 * 24));
        },
        vipPackages() {
            return [
                {
                    id: 0,
                    days: 3,
                    price: this.formatPrice(this.init.costs.vip_3_price),
                },
                {
                    id: 1,
                    days: 10,
                    price: this.formatPrice(this.init.costs.vip_10_price),
                },
                {
                    id: 2,
                    days: 30,
                    price: this.formatPrice(this.init.costs.vip_30_price),
                },
                {
                    id: 3,
                    days: 90,
                    price: this.formatPrice(this.init.costs.vip_90_price),
                },
                {
                    id: 4,
                    days: 180,
                    price: this.formatPrice(this.init.costs.vip_180_price),
                },
                {
                    id: 5,
                    days: 365,
                    price: this.formatPrice(this.init.costs.vip_365_price),
                },
            ];
        },
    },
    methods: {
        beforeOpen() {
            this.checkScroll();
        },
        beforeClose() {
            this.checkRemoveScroll();
        },
        confirm() {
            if (
                parseFloat(this.user.balance) <
                parseFloat(this.vipPackages[this.currentPackage].price)
            ) {
                return;
            }
            this.$store
                .dispatch("user/vip", {
                    days: this.vipPackages[this.currentPackage].days,
                })
                .then(() => {
                    this.$modal.hide("vip-buy");
                    this.$store.dispatch("guests/get");
                    this.$modal.show("dialog", {
                        title: this.$t("roulette.success"),
                        text:
                            this.$t("vipbuy.vipDays") +
                            this.getDMY(this.user.vip_end * 1000) +
                            " " +
                            this.getHM(this.user.vip_end * 1000),
                        buttons: [
                            {
                                title: this.$t("roulette.ok"),
                            },
                        ],
                    });
                })
                .catch(() => {
                    this.$modal.hide("vip-buy");
                });
        },
        formatPrice(price) {
            let arr = price.split(".");
            return arr[1] == "00" ? arr[0] : price;
        },
        close() {
            this.$modal.hide("vip-buy");
        },
    },
};
</script>

<style lang="scss">
@import "~@/assets/styles/layout/_vip";

.error-modal {
    transition: box-shadow 1s;

    &.has-bugs {
        box-shadow: 0 24px 80px -2px rgba(255, 0, 0, 0.4) !important;
    }
}
</style>
